import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } from "recharts";
import { bin as d3bin, extent } from "d3-array";

interface Props {
    data: { value: number }[];
}

export function HistogramWidget({ data }: Props) {
    const values = data
        ?.map((d) => d.value)
        .filter((v) => typeof v === "number" && !isNaN(v)) || [];

    if (values.length === 0) return <p style={{ color: 'var(--text-muted)' }}>No numeric data available.</p>;

    // Compute bins
    const [min, max] = extent(values);
    const binGenerator = d3bin().domain([min ?? 0, max ?? 1]).thresholds(20);
    const bins = binGenerator(values);

    const binData = bins.map((bin) => ({
        binLabel: `${bin.x0?.toFixed(2)}–${bin.x1?.toFixed(2)}`,
        count: bin.length,
    }));

    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart data={binData}>
                <XAxis
                    dataKey="binLabel"
                    angle={-45}
                    textAnchor="end"
                    height={60}
                    tick={{ fill: 'var(--text-muted)', fontSize: 10 }}
                />
                <YAxis tick={{ fill: 'var(--text-muted)' }} />
                <Tooltip
                    contentStyle={{
                        background: 'var(--bg-panel)',
                        border: '1px solid var(--surface-glass-border)',
                        borderRadius: '4px'
                    }}
                    animationDuration={0}
                />
                <Bar dataKey="count" fill="var(--accent-primary)" isAnimationActive={false} />
            </BarChart>
        </ResponsiveContainer>
    );
}

